export default function() {
    return {
        users: [],
        page: 1,
        totalRows: 0,
        perPage: 15,
        totalPages: 0,
        searchParams: {
            roles: null
        },
        impersonateModal: false,
        availableRoles: [
            {
                label: 'Todos',
                value: null,
            },
            {
                label: 'Administrador',
                value: 'ROLE_ADMIN'
            },
            {
                label: 'Atendimento',
                value: 'ROLE_SERVICE'
            },
            {
                label: 'Comprador',
                value: 'ROLE_CUSTOMER'
            },
            {
                label: 'Agência',
                value: 'ROLE_AGENCY'
            }
        ],
        fields: [
            {
                key: 'id',
                label: 'ID usuário'
            },
            {
                key: 'name',
                label: 'Nome'
            },
            {
                key: 'email',
                label: 'Email'
            },
            {
                key: 'role',
                label: 'Tipo'
            },
            {
                key: 'lastLogin',
                label: 'Último login'
            },
            {
                key: 'agency',
                label: 'Agência'
            },
            {
                key: 'actions',
                label: 'Ações'
            }
        ]
    }
}
